import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InvoiceStatus, VisibilityStatus } from '../../../../core/interfaces/invoice-interfaces';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-invoice-status',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './invoice-status.component.html',
  styleUrl: './invoice-status.component.css'
})
export class InvoiceStatusComponent {
  InvoiceStatus = InvoiceStatus;
  VisibilityStatus = VisibilityStatus;

  @Input() status: boolean | null = null;
  @Input() statusOkColor: string = '#A9BE92';

  @Input() statusEnum: InvoiceStatus | null = null;
  @Input() visibilityStatus: VisibilityStatus = VisibilityStatus.READY_FOR_USER;
}
